import { ReactNode, createContext, useContext, useCallback } from 'react'
import { useHowlPlayer } from './useHowlPlayer'
import { Song } from '../../utils/redux/songsSlice'

interface PlayerContextProps {
  howl: Howl | undefined
  play: () => void
  pause: () => void
  setQueue: (songs: Song[]) => void
}

const PlayerContext = createContext<PlayerContextProps>({
  howl: undefined,
  play: () => {},
  pause: () => {},
  setQueue: () => {},
})

export const PlayerProvider = ({ children }: { children: ReactNode }) => {
  const { howl, setQueue } = useHowlPlayer()

  const play = useCallback(() => {
    howl?.play()
  }, [howl])

  const pause = useCallback(() => {
    howl?.pause()
  }, [howl])

  return (
    <PlayerContext.Provider value={{ howl, play, pause, setQueue }}>
      {children}
    </PlayerContext.Provider>
  )
}

export const usePlayerContext = () => {
  const context = useContext(PlayerContext)
  if (!context) {
    throw new Error('usePlayerContext must be used within a PlayerProvider')
  }
  return context
}
